// extracted by mini-css-extract-plugin
export default {"relatedCardsContainer":"relatedCards_relatedCardsContainer__Alyq6","cardWrapper":"relatedCards_cardWrapper__QIGvr","relatedCard":"relatedCards_relatedCard__w2Hxx"};